import { useLang } from '@/i18n';
import EcoSpace from 'eco-design/base/eco-space';
import EcoSectionCarousel, { EcoSectionCarouselItemProps } from 'eco-design/sections/eco-section-carousel';
import styles from './index.module.scss';
import { useEffect, useState } from 'react';
import { Swiper } from 'swiper/types';

const JB: React.FC = () => {
    const { t } = useLang('delta3series');
    const [swiperDom, setSwiperDom] = useState<Swiper>();
    const itemsA: EcoSectionCarouselItemProps[] = [
        {
            icon: '',
            pc: 'https://websiteoss.ecoflow.com/upload/image/1741587961993/Frame%201000008450.jpg',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1741587961993/Frame%201000008450.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1741587984236/1.jpg',
            title: t('B_item1_title'),
            desc: t('B_item1_desc'),
        },
        {
            icon: '',
            pc: 'https://websiteoss.ecoflow.com/upload/image/1740642036137/Group%201000008393.jpg',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1740642036137/Group%201000008393.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1740707489557/2.jpg',
            title: t('B_item2_title'),
            desc: t('B_item2_desc'),
        },
        {
            icon: '',
            pc: 'https://websiteoss.ecoflow.com/upload/image/1740642035886/3.jpg',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1740642035886/3.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1740707490301/3.jpg',
            title: t('B_item3_title'),
            desc: t('B_item3_desc'),
        },
        {
            icon: '',
            pc: 'https://websiteoss.ecoflow.com/upload/image/1740642034948/4.jpg',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1740642034948/4.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1740707582136/4.jpg',
            title: t('B_item4_title'),
            desc: t('B_item4_desc'),
        },
        {
            icon: '',
            pc: 'https://websiteoss.ecoflow.com/upload/image/1740642035550/5.jpg',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1740642035550/5.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1740707490083/5.jpg',
            title: t('B_item5_title'),
            desc: t('B_item5_desc'),
        },
    ];

    // 是否进入视图
    const enterViewChange = () => {
        const elem = document.querySelector('#d3-B');
        if (elem) {
            const ob1 = new IntersectionObserver((elems) => {
                const elem = elems[0];
                if (elem.isIntersecting) {
                    swiperDom && swiperDom?.slideTo(0, 100, false);
                }
            });
            ob1.observe(elem);
        }
    };
    useEffect(() => {
        enterViewChange();
    }, [swiperDom]);
    return (
        <div className={styles.comp} id="d3-B">
            <EcoSpace />
            <EcoSectionCarousel
                autoplay={{
                    delay: 3000,
                    stopOnLastSlide: false,
                    disableOnInteraction: false,
                }}
                swiperAutoPlay={true}
                label={t('B_label')}
                title={t('B_title')}
                desc={t('B_desc')}
                items={itemsA}
                getSwiperDom={(data: any) => {
                    setSwiperDom(data);
                }}
            />
        </div>
    );
};

export default JB;
